import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import Swal from 'sweetalert2';
import { environment } from '../../environments/environment';
import { MessageService } from '../services/message.service';
@Component({
    selector: 'app-feedback-popup',
    imports: [FormsModule, CommonModule],
    templateUrl: './feedback-popup.component.html',
    styleUrl: './feedback-popup.component.scss'
})
export class FeedbackPopupComponent {
  isPopupActive = false;
  selectedOption = 'Suggestion';
  feedbackText = '';
  userId = localStorage.getItem("email" ); 

  private http = inject(HttpClient);
  private messageService = inject(MessageService);

  openPopup() {
    this.isPopupActive = true;
  }

  closePopup() {
    this.isPopupActive = false;
  }

  submitFeedback() {
  
    
 if (!this.feedbackText.trim()) {
  this.messageService.showFeedbackMissing();
  return;
}

    const payload = {
      user_id: this.userId,
      type: this.selectedOption,
      description: this.feedbackText,
      db_name: environment.dbName
    };

    this.http.post(`${environment.apiBaseUrl}/feedback`, payload)
    .subscribe({
  next: (response) => {
    console.log('Feedback submitted:', response);
    // First close the popup
    this.closePopup();
    // Then show the success message
    this.messageService.showFeedbackSuccess().then((result) => {
      // Reset form after user dismisses the alert
      this.feedbackText = '';
      this.selectedOption = 'Suggestion';
    });
  },
  error: (error) => {
    console.error('Error submitting feedback:', error);
    this.messageService.showFeedbackError();
  }
});
  }

  resetForm() {
    this.feedbackText = '';
    this.selectedOption = 'Suggestion';
    this.closePopup();
  }

  selectOption(option: string) {
    this.selectedOption = option;
  }
}
